export const licenseKey = 'ewogICJmb3JtYXQiOiAxLAogICJjdXN0b21lcklkIjogIjdhNmEyMTljLWJmZjAtMTFlMy04MGMwLTAwMTU1ZDYyNDcwMSIsCiAgIm1heFZlcnNpb25BbGxvd2VkIjogMjUyCn0=.tmXIO8EXeUsrYc5ePGytB5S0XS+fkkQe6/uQuZZeMtLiOZ2MG/BlbpxWRuIexCtrM7ywuIxFH0TBZTtxgs0EyRubxID8VIXk74i0QvoYJj/SbJ2FcKb9+7XjcrF7tS01rh25Mw=='


